// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/accordion-pane","root":"accordion-pane-m__root__1sHNW"};